// extracted by mini-css-extract-plugin
export default {"fullWidth":"Xo-z","image":"Yo-z","lazyLoadPicture":"Zo-z","lazyLoadSpinner":"_o-z","lazyLoadSpin":"ap-z","lazyLoadImage":"bp-z","hasStyledAspectRatio":"cp-z"};